
import React from "react";
import { ChevronLeft, ChevronRight, ChevronUp } from "lucide-react";
import { motion } from "framer-motion";

interface ScrollButtonProps {
  direction: "left" | "right" | "up";
  visible: boolean;
  onClick: () => void;
}

const ScrollButton = ({ direction, visible, onClick }: ScrollButtonProps) => {
  const isLeft = direction === "left";
  const isRight = direction === "right";
  const isUp = direction === "up";
  
  // Different styling based on direction
  let className = "bg-black/60 hover:bg-black/80 text-white rounded-full p-2 transition-all";
  
  if (isLeft || isRight) {
    className = `absolute ${isLeft ? 'left-0' : 'right-0'} top-1/2 transform -translate-y-1/2 z-20 ${className} ${!visible ? 'pointer-events-none' : ''}`;
  } else if (isUp) {
    className = `${className} ${!visible ? 'pointer-events-none' : ''}`;
  }
  
  // Initial animation based on direction
  const initialX = isLeft ? -10 : (isRight ? 10 : 0);
  const initialY = isUp ? 10 : 0;
  
  return (
    <motion.button 
      initial={{ opacity: 0, x: initialX, y: initialY }}
      animate={{ opacity: visible ? 1 : 0, x: 0, y: 0 }}
      transition={{ duration: 0.3 }}
      onClick={onClick}
      className={className}
      aria-label={`Scroll ${direction}`}
    >
      {isLeft && <ChevronLeft size={24} />}
      {isRight && <ChevronRight size={24} />}
      {isUp && <ChevronUp size={24} />}
    </motion.button>
  );
};

export default ScrollButton;
